import styled from "styled-components";

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
  padding: 12px 0;
  user-select: none;
  touch-action: manipulation;
  box-sizing: border-box;
  background:
    radial-gradient(900px 520px at 20% 10%, rgba(255, 210, 240, 0.55) 0%, transparent 55%),
    radial-gradient(900px 520px at 80% 0%, rgba(190, 230, 255, 0.6) 0%, transparent 55%),
    radial-gradient(1100px 700px at 50% 100%, rgba(205, 255, 225, 0.55) 0%, transparent 60%),
    linear-gradient(180deg, #f8fbff 0%, #f7f7ff 40%, #f7fbff 100%);

  * {
    box-sizing: border-box;
  }

  .bgStars,
  .bgClouds,
  .bgDots {
    position: absolute;
    inset: 0;
    pointer-events: none;
    z-index: 0;
  }

  .bgStars {
    opacity: 0.95;
  }

  .cloud {
    position: absolute;
    width: 200px;
    height: 66px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.74);
    box-shadow:
      0 20px 34px rgba(148, 163, 184, 0.09),
      inset 0 1px 0 rgba(255, 255, 255, 0.9);
    opacity: 0.88;
    animation: floatCloud 7s ease-in-out infinite;
  }

  .cloud::before,
  .cloud::after {
    content: "";
    position: absolute;
    bottom: 18px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.84);
  }

  .cloud::before {
    left: 22px;
    width: 54px;
    height: 54px;
  }

  .cloud::after {
    right: 24px;
    width: 64px;
    height: 64px;
  }

  .c1 {
    left: 5%;
    top: 16%;
    --cloud-scale: 0.88;
    animation-delay: 0.3s;
  }

  .c2 {
    right: 6%;
    top: 18%;
    --cloud-scale: 0.96;
    animation-delay: 1.2s;
  }

  .c3 {
    right: 12%;
    bottom: 10%;
    --cloud-scale: 0.72;
    animation-delay: 2s;
  }

  .dot {
    position: absolute;
    border-radius: 999px;
    filter: blur(0.3px);
  }

  .d1 {
    left: 8%;
    top: 52%;
    width: 20px;
    height: 20px;
    background: rgba(251, 207, 232, 0.84);
  }

  .d2 {
    right: 10%;
    top: 60%;
    width: 14px;
    height: 14px;
    background: rgba(191, 219, 254, 0.9);
  }

  .d3 {
    left: 22%;
    top: 14%;
    width: 10px;
    height: 10px;
    background: rgba(253, 224, 71, 0.82);
  }

  .d4 {
    right: 18%;
    top: 18%;
    width: 16px;
    height: 16px;
    background: rgba(167, 243, 208, 0.85);
  }

  .d5 {
    right: 24%;
    bottom: 12%;
    width: 14px;
    height: 14px;
    background: rgba(251, 146, 60, 0.78);
  }

  .star {
    position: absolute;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    animation: twinkle 2.8s ease-in-out infinite;
    filter: drop-shadow(0 8px 12px rgba(15, 23, 42, 0.08));
  }

  .star svg {
    width: 28px;
    height: 28px;
    color: rgba(250, 204, 21, 0.92);
  }

  .s1 {
    left: 6%;
    top: 12%;
    animation-delay: 0.1s;
  }

  .s2 {
    left: 14%;
    top: 34%;
    animation-delay: 0.7s;
  }

  .s3 {
    right: 14%;
    top: 16%;
    animation-delay: 0.4s;
  }

  .s4 {
    right: 7%;
    top: 42%;
    animation-delay: 1.1s;
  }

  .s5 {
    left: 50%;
    top: 9%;
    transform: translateX(-50%);
    animation-delay: 0.5s;
  }

  @keyframes twinkle {
    0%, 100% {
      transform: translateY(0) scale(1);
      opacity: 0.72;
    }
    50% {
      transform: translateY(-6px) scale(1.08);
      opacity: 1;
    }
  }

  @keyframes floatCloud {
    0%, 100% {
      transform: translateY(0) scale(var(--cloud-scale, 1));
    }
    50% {
      transform: translateY(-8px) scale(var(--cloud-scale, 1));
    }
  }

  .shell {
    position: relative;
    z-index: 1;
    width: min(95vw, 1040px);
    height: calc(100vh - 24px);
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .headerBox {
    flex: 0 0 144px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 8px;
    position: relative;
    z-index: 2;
  }

  .brandRow {
    width: 100%;
    height: 100%;
    border-radius: 34px;
    padding: 18px 28px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    background: rgba(255, 255, 255, 0.86);
    backdrop-filter: blur(10px);
    border: 2px solid rgba(255, 255, 255, 0.62);
    box-shadow:
      0 16px 50px rgba(15, 23, 42, 0.08),
      inset 0 1px 0 rgba(255, 255, 255, 0.7);
  }

  .brandMain {
    min-width: 0;
    flex: 1;
    display: flex;
    align-items: center;
    gap: 18px;
  }

  .mascot {
    width: 92px;
    height: 92px;
    flex: 0 0 92px;
    border-radius: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, rgba(248, 250, 252, 0.94) 100%);
    border: 2px solid rgba(15, 23, 42, 0.04);
    box-shadow:
      0 14px 34px rgba(15, 23, 42, 0.08),
      inset 0 1px 0 rgba(255, 255, 255, 0.92);
  }

  .mascotIcon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .mascotIcon svg {
    width: 52px;
    height: 52px;
    color: #f59e0b;
    filter: drop-shadow(0 6px 10px rgba(245, 158, 11, 0.18));
  }

  .brandText {
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 6px;
  }

  .brandEyebrow {
    color: #ea580c;
    font-size: 13px;
    font-weight: 1000;
    letter-spacing: 0.16em;
  }

  .brandTitle {
    margin: 0;
    color: #0f172a;
    font-size: clamp(38px, 4.2vw, 68px);
    font-weight: 1000;
    line-height: 1.02;
    letter-spacing: -0.06em;
    word-break: keep-all;
  }

  .brandSub {
    margin: 0;
    color: #64748b;
    font-size: clamp(17px, 1.5vw, 26px);
    font-weight: 900;
    line-height: 1.2;
    letter-spacing: -0.03em;
    word-break: keep-all;
  }

  .brandAside {
    flex: 0 0 320px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    gap: 12px;
  }

  .brandChips {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 10px;
  }

  .brandChip {
    min-height: 36px;
    padding: 0 14px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 1000;
    letter-spacing: -0.02em;
    box-shadow:
      0 10px 22px rgba(15, 23, 42, 0.06),
      inset 0 1px 0 rgba(255, 255, 255, 0.9);
    white-space: nowrap;
  }

  .brandChip.peach {
    background: linear-gradient(180deg, #fff7ed 0%, #ffe4e6 100%);
    color: #c2410c;
  }

  .brandChip.mint {
    background: linear-gradient(180deg, #ecfeff 0%, #dcfce7 100%);
    color: #0f766e;
  }

  .brandBubble {
    width: 100%;
    min-height: 62px;
    padding: 0 18px;
    border-radius: 999px;
    display: flex;
    align-items: center;
    gap: 12px;
    background: linear-gradient(180deg, #fff8ef 0%, #fff1f2 100%);
    border: 2px solid rgba(251, 146, 60, 0.12);
    color: #7c2d12;
    font-size: 18px;
    font-weight: 900;
    letter-spacing: -0.03em;
    box-shadow:
      0 14px 28px rgba(249, 115, 22, 0.1),
      inset 0 1px 0 rgba(255, 255, 255, 0.9);
  }

  .brandBubbleIcon {
    width: 40px;
    height: 40px;
    flex: 0 0 40px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(180deg, #fff1f2 0%, #ffe4e6 100%);
    color: #f97316;
    box-shadow: 0 10px 18px rgba(249, 115, 22, 0.12);
  }

  .brandBubbleIcon svg {
    width: 20px;
    height: 20px;
  }

  .monotiQrBubble {
    position: relative;
    width: 100%;
    min-height: 102px;
    padding: 14px 18px 14px 14px;
    border-radius: 28px;
    display: flex;
    align-items: center;
    gap: 14px;
    background: linear-gradient(180deg, #fffefa 0%, #fff7ed 100%);
    border: 2px solid rgba(249, 115, 22, 0.14);
    box-shadow:
      0 18px 34px rgba(249, 115, 22, 0.12),
      inset 0 1px 0 rgba(255, 255, 255, 0.94);
    animation: floatGuideBubble 3.8s ease-in-out infinite;
  }

  .monotiQrBubble::after {
    content: "";
    position: absolute;
    left: 26px;
    bottom: -10px;
    width: 22px;
    height: 22px;
    background: #fff8ee;
    border-right: 2px solid rgba(249, 115, 22, 0.14);
    border-bottom: 2px solid rgba(249, 115, 22, 0.14);
    transform: rotate(35deg) skewX(-10deg);
    border-bottom-right-radius: 8px;
  }

  .monotiQrThumb {
    width: 74px;
    height: 74px;
    flex: 0 0 74px;
    padding: 8px;
    border-radius: 22px;
    background: rgba(255, 255, 255, 0.95);
    box-shadow:
      0 10px 22px rgba(15, 23, 42, 0.08),
      inset 0 1px 0 rgba(255, 255, 255, 0.96);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .monotiQrThumb img {
    width: 100%;
    height: 100%;
    display: block;
    border-radius: 12px;
    object-fit: cover;
  }

  .monotiQrCopy {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .monotiQrBadge {
    width: fit-content;
    min-height: 28px;
    padding: 0 10px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: linear-gradient(180deg, #fff1f2 0%, #ffe4e6 100%);
    color: #e11d48;
    font-size: 11px;
    font-weight: 1000;
    letter-spacing: 0.1em;
    box-shadow:
      0 8px 16px rgba(244, 63, 94, 0.1),
      inset 0 1px 0 rgba(255, 255, 255, 0.92);
  }

  .monotiQrBadge .icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .monotiQrBadge .icon svg {
    width: 12px;
    height: 12px;
  }

  .monotiQrTitle {
    color: #7c2d12;
    font-size: 18px;
    font-weight: 1000;
    line-height: 1.34;
    letter-spacing: -0.03em;
    word-break: keep-all;
  }

  .monotiQrDesc {
    color: #9a3412;
    font-size: 14px;
    font-weight: 800;
    line-height: 1.3;
    letter-spacing: -0.02em;
  }

  @keyframes floatGuideBubble {
    0%, 100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-4px);
    }
  }

  .contentBox {
    flex: 1;
    min-height: 0;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(2, minmax(0, 1fr));
    gap: 14px;
    padding: 0 8px;
    position: relative;
    z-index: 1;
  }

  .actionCard {
    position: relative;
    min-height: 0;
    height: 100%;
    display: block;
    overflow: hidden;
    border-radius: 38px;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    background: rgba(255, 255, 255, 0.86);
    backdrop-filter: blur(10px);
    border: 2px solid rgba(255, 255, 255, 0.62);
    box-shadow:
      0 24px 70px rgba(15, 23, 42, 0.1),
      inset 0 1px 0 rgba(255, 255, 255, 0.72);
    transition: transform 0.14s ease, box-shadow 0.14s ease, filter 0.14s ease;
  }

  .actionCard:hover {
    transform: translateY(-3px);
    box-shadow:
      0 32px 90px rgba(15, 23, 42, 0.13),
      inset 0 1px 0 rgba(255, 255, 255, 0.76);
  }

  .actionCard:active {
    transform: translateY(-1px) scale(0.997);
  }

  .actionCard:focus-visible {
    outline: 4px solid rgba(37, 99, 235, 0.25);
    outline-offset: 6px;
  }

  .actionCard::before {
    content: "";
    position: absolute;
    inset: 0;
    pointer-events: none;
    opacity: 0.95;
  }

  .actionCard.keep::before {
    background:
      radial-gradient(680px 240px at 16% 18%, rgba(191, 219, 254, 0.36) 0%, transparent 58%),
      radial-gradient(420px 220px at 85% 85%, rgba(167, 243, 208, 0.16) 0%, transparent 60%);
  }

  .actionCard.find::before {
    background:
      radial-gradient(680px 240px at 16% 18%, rgba(251, 207, 232, 0.3) 0%, transparent 58%),
      radial-gradient(420px 220px at 85% 85%, rgba(253, 186, 116, 0.16) 0%, transparent 60%);
  }

  .ribbon {
    position: absolute;
    left: 0;
    top: 0;
    width: 22px;
    height: 100%;
    pointer-events: none;
    opacity: 0.96;
  }

  .actionCard.keep .ribbon {
    background: linear-gradient(180deg, #7dd3fc 0%, #60a5fa 42%, #34d399 100%);
  }

  .actionCard.find .ribbon {
    background: linear-gradient(180deg, #fda4af 0%, #fb7185 42%, #fdba74 100%);
  }

  .cardInner {
    position: relative;
    height: 100%;
    padding: 34px 34px 28px 44px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 16px;
  }

  .cardTop {
    flex: 1;
    min-height: 0;
    display: grid;
    grid-template-columns: 220px 1fr 180px;
    align-items: center;
    gap: 22px;
  }

  .cardBottom {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 14px;
    padding-top: 10px;
  }

  .emojiBubble {
    position: relative;
    width: 190px;
    height: 190px;
    border-radius: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    background:
      radial-gradient(90px 90px at 30% 24%, rgba(255, 255, 255, 0.96) 0%, rgba(255, 255, 255, 0.55) 56%, transparent 72%),
      linear-gradient(135deg, rgba(255, 255, 255, 0.96) 0%, rgba(248, 250, 252, 0.82) 100%);
    border: 2px solid rgba(15, 23, 42, 0.04);
    box-shadow:
      0 20px 56px rgba(15, 23, 42, 0.1),
      inset 0 1px 0 rgba(255, 255, 255, 0.9);
  }

  .emojiIcon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .emojiIcon svg {
    width: 104px;
    height: 104px;
    color: #0f172a;
    filter: drop-shadow(0 10px 14px rgba(0, 0, 0, 0.1));
  }

  .actionCard.keep .emojiIcon svg {
    color: #d97706;
  }

  .actionCard.find .emojiIcon svg {
    color: #0f172a;
  }

  .bubbleHighlight {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 26px;
    height: 26px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.84);
  }

  .text {
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 10px;
  }

  .guideBadge {
    width: fit-content;
    min-height: 40px;
    padding: 0 18px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 1000;
    letter-spacing: -0.03em;
    box-shadow:
      0 10px 22px rgba(15, 23, 42, 0.08),
      inset 0 1px 0 rgba(255, 255, 255, 0.92);
  }

  .guideBadge.keep {
    background: linear-gradient(180deg, #eff6ff 0%, #e0f2fe 100%);
    color: #1d4ed8;
    border: 1px solid rgba(59, 130, 246, 0.16);
  }

  .guideBadge.find {
    background: linear-gradient(180deg, #fff1f2 0%, #ffedd5 100%);
    color: #e11d48;
    border: 1px solid rgba(251, 113, 133, 0.18);
  }

  .title {
    margin: 0;
    color: #0f172a;
    font-size: clamp(54px, 5.2vw, 88px);
    font-weight: 1000;
    line-height: 1.02;
    letter-spacing: -0.07em;
    word-break: keep-all;
  }

  .sub {
    margin: 0;
    color: #64748b;
    font-size: clamp(24px, 2vw, 30px);
    font-weight: 900;
    line-height: 1.2;
    letter-spacing: -0.03em;
    word-break: keep-all;
  }

  .helperText {
    color: #64748b;
    font-size: 18px;
    font-weight: 800;
    line-height: 1.32;
    letter-spacing: -0.03em;
    word-break: keep-all;
  }

  .meta {
    display: inline-flex;
    align-items: center;
    min-height: 50px;
    padding: 0 20px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.62);
    border: 1px solid rgba(15, 23, 42, 0.06);
    color: #94a3b8;
    font-size: 19px;
    font-weight: 800;
    letter-spacing: -0.02em;
  }

  .ctaRow {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .cta {
    height: 88px;
    min-width: 160px;
    padding: 0 22px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    font-size: 30px;
    font-weight: 1000;
    letter-spacing: -0.04em;
    background: rgba(96, 165, 250, 0.15);
    color: #2563eb;
    border: 2px solid rgba(96, 165, 250, 0.18);
    box-shadow: 0 14px 32px rgba(37, 99, 235, 0.1);
  }

  .ctaArrow {
    width: 36px;
    height: 36px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.4);
  }

  .ctaArrow svg {
    width: 18px;
    height: 18px;
  }

  .actionCard.find .cta {
    background: rgba(251, 113, 133, 0.14);
    color: #e11d48;
    border: 2px solid rgba(251, 113, 133, 0.18);
    box-shadow: 0 14px 32px rgba(225, 29, 72, 0.1);
  }

  .speechPromo {
    position: relative;
    align-self: flex-start;
    width: 100%;
    min-height: 104px;
    padding: 18px 20px 18px 100px;
    border-radius: 28px;
    background: linear-gradient(180deg, #fff8ef 0%, #fff1e7 100%);
    border: 2px solid rgba(249, 115, 22, 0.14);
    box-shadow:
      0 16px 32px rgba(249, 115, 22, 0.12),
      inset 0 1px 0 rgba(255, 255, 255, 0.92);
  }

  .speechBall {
    position: absolute;
    top: 14px;
    right: 14px;
    width: 20px;
    height: 20px;
    border-radius: 999px;
    background: #fff;
    border: 2px solid rgba(239, 68, 68, 0.3);
    box-shadow: 0 8px 12px rgba(239, 68, 68, 0.12);
  }

  .speechBall::before,
  .speechBall::after {
    content: "";
    position: absolute;
    top: 2px;
    bottom: 2px;
    width: 4px;
    border: 1.5px solid rgba(239, 68, 68, 0.42);
    border-top-color: transparent;
    border-bottom-color: transparent;
    border-radius: 999px;
  }

  .speechBall::before {
    left: 2px;
    transform: rotate(14deg);
  }

  .speechBall::after {
    right: 2px;
    transform: rotate(-14deg);
  }

  .speechPromo::after {
    content: "";
    position: absolute;
    left: 18px;
    bottom: -10px;
    width: 24px;
    height: 24px;
    background: #fff3e8;
    border-right: 2px solid rgba(249, 115, 22, 0.14);
    border-bottom: 2px solid rgba(249, 115, 22, 0.14);
    transform: rotate(35deg) skewX(-10deg);
    border-bottom-right-radius: 8px;
  }

  .speechMascot {
    position: absolute;
    left: 16px;
    top: 50%;
    width: 68px;
    height: 68px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translateY(-50%);
    background:
      radial-gradient(42px 42px at 30% 30%, rgba(255, 255, 255, 0.96) 0%, rgba(255, 255, 255, 0.6) 60%, transparent 75%),
      linear-gradient(180deg, #fff 0%, #fff8ef 100%);
    box-shadow: 0 10px 22px rgba(249, 115, 22, 0.14);
  }

  .speechPlanet {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .speechPlanet svg {
    width: 38px;
    height: 38px;
    color: #f59e0b;
  }

  .speechSparkle {
    position: absolute;
    top: 8px;
    right: 8px;
    display: inline-flex;
    color: rgba(250, 204, 21, 0.95);
  }

  .speechSparkle svg {
    width: 16px;
    height: 16px;
  }

  .speechCopy {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .speechEyebrow {
    color: #ea580c;
    font-size: 12px;
    font-weight: 1000;
    letter-spacing: 0.12em;
  }

  .speechTitle {
    color: #7c2d12;
    font-size: 24px;
    font-weight: 1000;
    line-height: 1.12;
    letter-spacing: -0.04em;
    word-break: keep-all;
  }

  .speechDesc {
    color: #9a3412;
    font-size: 15px;
    font-weight: 800;
    line-height: 1.35;
    letter-spacing: -0.02em;
    word-break: keep-all;
  }

  .warningPanel {
    position: relative;
    overflow: hidden;
    width: 100%;
    display: grid;
    grid-template-columns: 72px minmax(0, 1fr);
    gap: 14px;
    align-items: center;
    padding: 18px 20px;
    border-radius: 28px;
    background: linear-gradient(180deg, #fff4f5 0%, #ffede8 100%);
    border: 2px solid rgba(239, 68, 68, 0.14);
    box-shadow:
      0 16px 34px rgba(239, 68, 68, 0.12),
      inset 0 1px 0 rgba(255, 255, 255, 0.92);
  }

  .warningPanel::before {
    content: "";
    position: absolute;
    inset: 0;
    pointer-events: none;
    opacity: 0.4;
    background:
      repeating-linear-gradient(
        -45deg,
        rgba(255, 255, 255, 0.36) 0,
        rgba(255, 255, 255, 0.36) 10px,
        rgba(255, 255, 255, 0) 10px,
        rgba(255, 255, 255, 0) 20px
      );
  }

  .warningIcon {
    position: relative;
    z-index: 1;
    width: 62px;
    height: 62px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(180deg, #fb7185 0%, #f97316 100%);
    color: #fff;
    font-size: 34px;
    font-weight: 1000;
    box-shadow: 0 12px 24px rgba(239, 68, 68, 0.18);
  }

  .warningIcon svg {
    width: 34px;
    height: 34px;
  }

  .warningCopy {
    position: relative;
    z-index: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .warningPill {
    width: fit-content;
    min-height: 30px;
    padding: 0 14px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.9);
    color: #e11d48;
    font-size: 12px;
    font-weight: 1000;
    letter-spacing: 0.08em;
  }

  .warningTitle {
    color: #9f1239;
    font-size: 28px;
    font-weight: 1000;
    line-height: 1.1;
    letter-spacing: -0.05em;
    word-break: keep-all;
  }

  .warningDesc {
    color: #9f1239;
    font-size: 16px;
    font-weight: 800;
    line-height: 1.3;
    letter-spacing: -0.03em;
    word-break: keep-all;
  }

  .chip {
    position: absolute;
    top: 20px;
    right: 20px;
    height: 40px;
    padding: 0 14px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #334155;
    font-size: 15px;
    font-weight: 1000;
    background: rgba(148, 163, 184, 0.18);
    border: 2px solid rgba(148, 163, 184, 0.2);
  }

  .actionCard.disabled,
  .actionCard[aria-disabled="true"] {
    cursor: not-allowed;
    opacity: 0.58;
    filter: grayscale(0.2);
  }

  .actionCard.disabled:hover,
  .actionCard[aria-disabled="true"]:hover {
    transform: none;
  }

  @media screen and (max-height: 820px) {
    .shell {
      width: 94vw;
      gap: 12px;
    }

    .headerBox {
      flex-basis: 126px;
      padding: 0 6px;
    }

    .brandRow {
      padding: 14px 22px;
    }

    .mascot {
      width: 84px;
      height: 84px;
      flex-basis: 84px;
    }

    .mascotIcon svg {
      width: 46px;
      height: 46px;
    }

    .brandAside {
      flex-basis: 288px;
      gap: 10px;
    }

    .brandBubble {
      min-height: 56px;
      font-size: 16px;
    }

    .cardInner {
      padding: 28px 28px 22px 38px;
      gap: 14px;
    }

    .cardTop {
      grid-template-columns: 180px 1fr 158px;
      gap: 18px;
    }

    .emojiBubble {
      width: 150px;
      height: 150px;
      border-radius: 44px;
    }

    .emojiIcon svg {
      width: 84px;
      height: 84px;
    }

    .title {
      font-size: 46px;
    }

    .sub {
      font-size: 20px;
    }

    .helperText {
      font-size: 16px;
    }

    .meta {
      min-height: 44px;
      font-size: 16px;
    }

    .cta {
      height: 74px;
      min-width: 142px;
      font-size: 25px;
    }

    .speechPromo,
    .warningPanel {
      min-height: 88px;
    }
  }

  @media screen and (max-width: 1024px) {
    .shell {
      width: calc(100% - 18px);
      height: calc(100% - 12px);
      gap: 12px;
      padding: 6px 0;
    }

    .headerBox {
      flex-basis: 118px;
      padding: 0 4px;
    }

    .brandRow {
      border-radius: 28px;
      padding: 14px 18px;
      gap: 14px;
    }

    .brandMain {
      gap: 14px;
    }

    .mascot {
      width: 74px;
      height: 74px;
      flex-basis: 74px;
      border-radius: 22px;
    }

    .mascotIcon svg {
      width: 40px;
      height: 40px;
    }

    .brandTitle {
      font-size: 34px;
    }

    .brandSub {
      font-size: 15px;
    }

    .brandAside {
      flex-basis: 270px;
      gap: 8px;
    }

    .brandChip {
      min-height: 32px;
      padding: 0 12px;
      font-size: 12px;
    }

    .brandBubble {
      min-height: 52px;
      padding: 0 14px;
      font-size: 15px;
    }

    .brandBubbleIcon {
      width: 34px;
      height: 34px;
      flex-basis: 34px;
    }

    .monotiQrBubble {
      min-height: 92px;
      padding: 12px;
      border-radius: 22px;
      gap: 10px;
    }

    .monotiQrThumb {
      width: 62px;
      height: 62px;
      flex-basis: 62px;
      border-radius: 18px;
      padding: 6px;
    }

    .monotiQrTitle {
      font-size: 15px;
    }

    .monotiQrDesc {
      font-size: 12px;
    }

    .contentBox {
      gap: 12px;
      padding: 0 4px;
    }

    .actionCard {
      border-radius: 28px;
    }

    .cardInner {
      padding: 20px 18px 16px 24px;
    }

    .cardTop {
      grid-template-columns: 110px 1fr 96px;
      gap: 12px;
    }

    .emojiBubble {
      width: 100px;
      height: 100px;
      border-radius: 28px;
    }

    .emojiIcon svg {
      width: 54px;
      height: 54px;
    }

    .bubbleHighlight {
      width: 18px;
      height: 18px;
      top: 10px;
      right: 10px;
    }

    .guideBadge {
      min-height: 32px;
      padding: 0 14px;
      font-size: 13px;
    }

    .title {
      font-size: 34px;
    }

    .sub {
      font-size: 16px;
    }

    .helperText {
      font-size: 13px;
    }

    .meta {
      min-height: 38px;
      padding: 0 14px;
      font-size: 13px;
    }

    .cta {
      height: 52px;
      min-width: 92px;
      font-size: 18px;
      padding: 0 12px;
    }

    .ctaArrow {
      width: 26px;
      height: 26px;
    }

    .ctaArrow svg {
      width: 14px;
      height: 14px;
    }

    .chip {
      top: 12px;
      right: 12px;
      height: 32px;
      padding: 0 10px;
      font-size: 12px;
    }
  }

  @media screen and (max-width: 540px) {
    .shell {
      width: calc(100% - 12px);
      height: calc(100% - 8px);
      gap: 10px;
      padding: 4px 0;
    }

    .headerBox {
      flex-basis: 92px;
      padding: 0 2px;
    }

    .brandRow {
      border-radius: 22px;
      padding: 10px 12px;
      gap: 10px;
      justify-content: flex-start;
    }

    .brandMain {
      gap: 10px;
    }

    .mascot {
      width: 58px;
      height: 58px;
      flex-basis: 58px;
      border-radius: 18px;
    }

    .mascotIcon svg {
      width: 30px;
      height: 30px;
    }

    .brandEyebrow {
      font-size: 9px;
    }

    .brandTitle {
      font-size: 26px;
    }

    .brandSub {
      font-size: 12px;
    }

    .brandAside {
      display: none;
    }

    .contentBox {
      gap: 10px;
      padding: 0 2px;
    }

    .actionCard {
      border-radius: 22px;
    }

    .cardInner {
      padding: 14px 12px 12px 18px;
    }

    .cardTop {
      grid-template-columns: 78px 1fr;
      gap: 10px;
    }

    .ctaRow {
      grid-column: 1 / -1;
      justify-content: flex-start;
    }

    .emojiBubble {
      width: 72px;
      height: 72px;
      border-radius: 22px;
    }

    .emojiIcon svg {
      width: 38px;
      height: 38px;
    }

    .title {
      font-size: 28px;
    }

    .sub {
      font-size: 12px;
    }

    .helperText {
      font-size: 11px;
      line-height: 1.25;
    }

    .guideBadge {
      min-height: 24px;
      padding: 0 10px;
      font-size: 10px;
    }

    .meta {
      min-height: 30px;
      padding: 0 10px;
      font-size: 11px;
    }

    .cta {
      height: 42px;
      min-width: 68px;
      font-size: 15px;
      padding: 0 8px;
      gap: 6px;
    }

    .ctaArrow {
      width: 20px;
      height: 20px;
    }

    .ctaArrow svg {
      width: 12px;
      height: 12px;
    }

    .speechPromo {
      min-height: 72px;
      padding: 10px 12px 10px 64px;
      border-radius: 18px;
    }

    .speechPromo::after {
      left: 12px;
      bottom: -6px;
      width: 14px;
      height: 14px;
      border-bottom-right-radius: 5px;
    }

    .speechMascot {
      left: 10px;
      width: 42px;
      height: 42px;
      border-radius: 14px;
    }

    .speechPlanet svg {
      width: 22px;
      height: 22px;
    }

    .speechSparkle svg {
      width: 10px;
      height: 10px;
    }

    .speechBall {
      top: 8px;
      right: 8px;
      width: 12px;
      height: 12px;
    }

    .speechTitle {
      font-size: 14px;
    }

    .speechDesc {
      font-size: 10px;
      line-height: 1.25;
    }

    .warningPanel {
      grid-template-columns: 40px minmax(0, 1fr);
      gap: 10px;
      padding: 10px 12px;
      border-radius: 18px;
    }

    .warningIcon {
      width: 34px;
      height: 34px;
      border-radius: 12px;
      font-size: 20px;
    }

    .warningIcon svg {
      width: 16px;
      height: 16px;
    }

    .warningPill {
      min-height: 18px;
      padding: 0 7px;
      font-size: 9px;
    }

    .warningTitle {
      font-size: 14px;
    }

    .warningDesc {
      font-size: 10px;
      line-height: 1.25;
    }

    .cloud {
      width: 150px;
      height: 48px;
    }

    .c2,
    .c3 {
      display: none;
    }

    .star svg {
      width: 16px;
      height: 16px;
    }
  }
`;

export const StorageContainer = styled.div`
  width: 100vw;
  height: 100vh;
  .content {
    width: 100vw;
    height: calc(100% - 86px);
    display: flex;
  }
  .sidemenu {
    width: 250px;
    height: 100%;
    background: #e9edf0;
    padding: 20px;
    position: relative;
    ul {
      height: calc(100% - 90px);
      li {
        width: 100%;
        font-size: 24px;
        font-weight: 700;
        border-radius: 20px;
        margin-bottom: 10px;
        text-align: center;
        &:last-child {
          margin-bottom: 0;
        }
        &:nth-child(even) {
          color: #a4a6a8;
        }
        &:nth-child(odd) {
          height: 80px;
          background: #fff;
          line-height: 80px;
        }
        &.active {
          background: #4c80f1;
          color: #fff;
        }
      }
    }
    .nextActionArea {
      width: 100%;
      position: relative;
    }
    .nextCue {
      position: absolute;
      left: 0;
      bottom: calc(100% + 24px);
      z-index: 2;
      width: 100%;
      min-height: 150px;
      padding: 18px 14px 48px;
      border: 3px solid #4c80f1;
      border-radius: 22px;
      background: #fff;
      color: #24324a;
      box-shadow: 0 18px 44px rgba(76, 128, 241, 0.24);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 6px;
      text-align: center;
      word-break: keep-all;
      pointer-events: none;
      animation: nextCueAppear 0.32s ease-out both;

      &::after {
        content: "";
        position: absolute;
        left: 50%;
        bottom: -14px;
        width: 24px;
        height: 24px;
        background: #fff;
        border-right: 3px solid #4c80f1;
        border-bottom: 3px solid #4c80f1;
        transform: translateX(-50%) rotate(45deg);
      }

      strong {
        color: #1d4ed8;
        font-size: 20px;
        line-height: 1.25;
        font-weight: 900;
      }

      span {
        font-size: 17px;
        line-height: 1.4;
        font-weight: 750;
      }

      b {
        color: #1d4ed8;
        font-weight: 950;
      }
    }
    .nextCueIcon {
      position: absolute;
      left: 50%;
      bottom: 12px;
      width: 34px;
      height: 34px;
      color: #4c80f1;
      transform: translateX(-50%);
      animation: nextCueBounce 1.15s ease-in-out infinite;
    }
    button {
      font-size: 30px;
      width: 100%;
      height: 90px;
      background: #4c80f1;
      color: #fff;
      border: none;
      border-radius: 20px;
      font-weight: 700;
    }
    button.nextButtonReady {
      animation: nextButtonPulse 1.6s ease-in-out infinite;
    }
  }

  @keyframes nextCueAppear {
    from {
      opacity: 0;
      transform: translateY(16px) scale(0.96);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  @keyframes nextCueBounce {
    0%, 100% {
      transform: translateX(-50%) translateY(-3px);
    }
    50% {
      transform: translateX(-50%) translateY(7px);
    }
  }

  @keyframes nextButtonPulse {
    0%, 100% {
      box-shadow: 0 0 0 0 rgba(76, 128, 241, 0.2);
      transform: scale(1);
    }
    50% {
      box-shadow: 0 0 0 12px rgba(76, 128, 241, 0);
      transform: scale(1.025);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .sidemenu .nextCue,
    .sidemenu .nextCueIcon,
    .sidemenu button.nextButtonReady {
      animation: none;
    }
  }
  .slideWrapper {
    overflow: hidden;
    display: flex;
    position: relative;
    height: 100%;
    .slideContent {
      flex: 0 0 100%;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      transition: 0.5s;
      overflow: hidden;
      .inputFields {
        height: 200px;
        input {
          width: 100%;
          height: 100%;
          font-size: 48px;
          height: 100%;
          text-align: center;
          font-weight: 700;
          border: 1px solid #e9edf0;
          &:focus {
            border: 1px solid #e9edf0 !important;
            box-shadow: none;
          }
        }
      }
      .fieldBox {
        height: calc(100% - 200px);
      }
            &.paymentSummary {
        background: radial-gradient(1200px 600px at 50% 20%, #eef4ff 0%, #f7f8fb 55%, #f5f6f8 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 44px 60px;
      }

      &.paymentSummary .payWrap {
        width: min(1040px, 100%);
        display: flex;
        flex-direction: column;
        gap: 22px;
      }

      &.paymentSummary .payHeader {
        text-align: center;
      }

      &.paymentSummary .badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        height: 42px;
        padding: 0 16px;
        border-radius: 999px;
        background: rgba(76, 128, 241, 0.12);
        color: #2f66e7;
        font-weight: 900;
        font-size: 18px;
        letter-spacing: 0.04em;
        margin-bottom: 10px;
      }

      &.paymentSummary .title {
        font-size: 54px;
        font-weight: 1000;
        letter-spacing: -0.04em;
        margin-bottom: 10px;
        color: #111827;
      }

      &.paymentSummary .sub {
        font-size: 22px;
        color: #6b7280;
        font-weight: 700;
      }

      &.paymentSummary .payCard {
        background: rgba(255, 255, 255, 0.9);
        border: 1px solid rgba(17, 24, 39, 0.08);
        border-radius: 28px;
        box-shadow: 0 28px 70px rgba(0, 0, 0, 0.10);
        padding: 34px;
        backdrop-filter: blur(8px);
      }

      &.paymentSummary .payCardTop {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        margin-bottom: 22px;
      }

      &.paymentSummary .cardTitle {
        font-size: 28px;
        font-weight: 1000;
        letter-spacing: -0.02em;
        color: #111827;
      }

      &.paymentSummary .cardDesc {
        margin-top: 6px;
        font-size: 18px;
        font-weight: 700;
        color: #6b7280;
      }

      &.paymentSummary .pill {
        height: 44px;
        padding: 0 18px;
        border-radius: 999px;
        background: rgba(17, 24, 39, 0.06);
        display: inline-flex;
        align-items: center;
        font-size: 18px;
        font-weight: 900;
        color: #111827;
      }

      &.paymentSummary .payList {
        display: flex;
        flex-direction: column;
        gap: 16px;
      }

      &.paymentSummary .payRow {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 22px 22px;
        border-radius: 20px;
        background: #f3f6fb;
        border: 1px solid rgba(17, 24, 39, 0.06);
      }

      &.paymentSummary .rowLeft {
        display: flex;
        align-items: center;
        gap: 16px;
      }

      &.paymentSummary .icon {
        width: 64px;
        height: 64px;
        border-radius: 18px;
        background: rgba(76, 128, 241, 0.12);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 30px;
      }

      &.paymentSummary .meta .name {
        font-size: 30px;
        font-weight: 1000;
        letter-spacing: -0.03em;
        color: #111827;
      }

      &.paymentSummary .meta .calc {
        margin-top: 6px;
        font-size: 20px;
        color: #6b7280;
        font-weight: 800;
      }

      &.paymentSummary .rowRight {
        font-size: 34px;
        font-weight: 1000;
        letter-spacing: -0.02em;
        color: #111827;
      }

      &.paymentSummary .divider {
        height: 1px;
        background: rgba(17, 24, 39, 0.10);
        margin: 22px 0;
      }

      &.paymentSummary .totalBox {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 24px 22px;
        border-radius: 22px;
        background: #e9efff;
        border: 1px solid rgba(76, 128, 241, 0.18);
      }

      &.paymentSummary .totalBox .label {
        font-size: 28px;
        font-weight: 1000;
        color: #111827;
      }

      &.paymentSummary .totalBox .value {
        font-size: 44px;
        font-weight: 1100;
        letter-spacing: -0.03em;
        color: #1d4ed8;
      }

      &.paymentSummary .payActions {
        margin-top: 22px;
        display: flex;
        flex-direction: column;
        gap: 12px;
      }

      &.paymentSummary .payBtn {
        width: 100%;
        height: 96px;
        border: none;
        border-radius: 24px;
        background: #4c80f1;
        color: #fff;
        font-size: 34px;
        font-weight: 1000;
        letter-spacing: -0.02em;
        cursor: pointer;
        transition: transform 0.08s ease, filter 0.12s ease;
      }

      &.paymentSummary .payBtn:active {
        transform: scale(0.99);
        filter: brightness(0.98);
      }

      &.paymentSummary .payBtn:disabled {
        background: #cbd5e1;
        cursor: not-allowed;
        transform: none;
        filter: none;
      }

      &.paymentSummary .hint {
        text-align: center;
        font-size: 18px;
        font-weight: 700;
        color: #6b7280;
      }
    }
  }
  @media screen and (max-width: 767px) {
    .content {
      flex-direction: column;
      .sidemenu {
        width: 100%;
        height: 100px;
        padding: 10px;
        ul {
          width: 100%;
          height: calc(100% - 50px);
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          li {
            height: auto;
            font-size: 12px;
            margin-bottom: 0;
            &:nth-child(odd) {
              line-height: 100%;
              padding: 10px 0;
            }
            &:nth-child(even) {
              width: auto;
              margin: 0 10px;
              transform: rotate(-90deg);
            }
          }
        }
        button {
          height: 30px;
          font-size: 16px;
          display: block;
          margin-left: auto;
        }
        .nextCue {
          display: none;
        }
      }
    }
  }
`;

export const StorageTypeContainer = styled.div`
  height: 100%;
  padding: 36px 42px 30px;
  box-sizing: border-box;
  background: radial-gradient(1200px 700px at 50% 0%, #eef4ff 0%, #f7f8fb 55%, #f5f6f8 100%);
  display: flex;
  flex-direction: column;

  &.storageModeKiosk .topBar {
    min-height: 120px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 24px;
    margin-bottom: 20px;
    flex-shrink: 0;
  }

  &.storageModeKiosk .topText {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  &.storageModeKiosk .topTitle {
    font-size: 54px;
    font-weight: 1000;
    letter-spacing: -0.04em;
    color: #111827;
    line-height: 1.05;
  }

  &.storageModeKiosk .topDesc {
    font-size: 21px;
    line-height: 1.55;
    font-weight: 700;
    color: #64748b;
    word-break: keep-all;
  }

  &.storageModeKiosk .topTotal {
    flex-shrink: 0;
    min-width: 128px;
    height: 62px;
    padding: 0 22px;
    border-radius: 999px;
    background: linear-gradient(180deg, #fff7ed 0%, #ffedd5 100%);
    color: #c2410c;
    border: 1px solid rgba(249, 115, 22, 0.16);
    box-shadow: 0 10px 24px rgba(249, 115, 22, 0.12);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-weight: 1000;
    letter-spacing: 0.04em;
  }

  &.storageModeKiosk .modeGrid {
    flex: 0 0 auto;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-auto-rows: max-content;
    align-content: start;
    align-items: start;
    gap: 22px;
  }

  &.storageModeKiosk .modeCard {
    min-width: 0;
    min-height: 0;
    max-height: 460px;
    display: flex;
    background: rgba(255, 255, 255, 0.96);
    border: 4px solid #d7dde5;
    border-radius: 30px;
    box-shadow: 0 18px 45px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    cursor: pointer;
    transition:
      transform 0.12s ease,
      box-shadow 0.12s ease,
      border-color 0.12s ease,
      filter 0.12s ease;
    -webkit-tap-highlight-color: transparent;
  }

  &.storageModeKiosk .modeCard:hover {
    transform: translateY(-3px);
    box-shadow: 0 22px 55px rgba(0, 0, 0, 0.12);
  }

  &.storageModeKiosk .modeCard:active {
    transform: translateY(-1px) scale(0.995);
    filter: brightness(0.99);
  }

  &.storageModeKiosk .modeCard:focus-visible {
    outline: 4px solid rgba(37, 99, 235, 0.2);
    outline-offset: 6px;
  }

  &.storageModeKiosk .modeCard.pickup.selected {
    border-color: #f97316;
    box-shadow: 0 24px 60px rgba(249, 115, 22, 0.18);
  }

  &.storageModeKiosk .modeCard.direct.selected {
    border-color: #4c80f1;
    box-shadow: 0 24px 60px rgba(76, 128, 241, 0.18);
  }

  &.storageModeKiosk .modeInner {
    width: 100%;
    padding: 24px 24px 20px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    min-height: 0;
  }

  &.storageModeKiosk .modeBadge {
    width: fit-content;
    min-height: 38px;
    padding: 0 14px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 1000;
    letter-spacing: 0.08em;
    box-shadow:
      0 10px 22px rgba(15, 23, 42, 0.08),
      inset 0 1px 0 rgba(255, 255, 255, 0.92);
  }

  &.storageModeKiosk .modeBadge.pickup {
    background: linear-gradient(180deg, #fff7ed 0%, #ffe4e6 100%);
    color: #c2410c;
  }

  &.storageModeKiosk .modeBadge.direct {
    background: linear-gradient(180deg, #eff6ff 0%, #e0f2fe 100%);
    color: #1d4ed8;
  }

  &.storageModeKiosk .modeIconWrap {
    width: 144px;
    height: 144px;
    border-radius: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow:
      inset 0 1px 0 rgba(255, 255, 255, 0.7),
      0 18px 34px rgba(15, 23, 42, 0.08);
  }

  &.storageModeKiosk .modeIconWrap.pickup {
    background: linear-gradient(180deg, rgba(255, 237, 213, 0.9) 0%, rgba(255, 247, 237, 0.98) 100%);
    color: #ea580c;
  }

  &.storageModeKiosk .modeIconWrap.direct {
    background: linear-gradient(180deg, rgba(219, 234, 254, 0.95) 0%, rgba(239, 246, 255, 0.98) 100%);
    color: #1d4ed8;
  }

  &.storageModeKiosk .modeIconWrap svg {
    width: 66px;
    height: 66px;
    stroke-width: 2.2;
  }

  &.storageModeKiosk .modeTitle {
    font-size: 34px;
    line-height: 1.12;
    font-weight: 1000;
    letter-spacing: -0.04em;
    color: #111827;
    word-break: keep-all;
  }

  &.storageModeKiosk .modeDesc {
    font-size: 19px;
    line-height: 1.5;
    font-weight: 700;
    color: #475569;
    word-break: keep-all;
  }

  &.storageModeKiosk .modeNote {
    width: fit-content;
    min-height: 38px;
    padding: 0 14px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    font-weight: 900;
    letter-spacing: -0.02em;
    background: rgba(15, 23, 42, 0.05);
    color: #475569;
    margin-top: auto;
  }

  &.storageModeKiosk .modeFooter {
    min-height: 64px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 18px;
    background: rgba(248, 250, 252, 0.95);
    border: 2px solid rgba(17, 24, 39, 0.06);
    flex-shrink: 0;
  }

  &.storageModeKiosk .modeState {
    font-size: 21px;
    font-weight: 1000;
    letter-spacing: -0.03em;
    color: #111827;
  }

  &.storageModeKiosk .modeCard.pickup.selected .modeState {
    color: #c2410c;
  }

  &.storageModeKiosk .modeCard.direct.selected .modeState {
    color: #1d4ed8;
  }

  &.storageModeKiosk .modeArrow {
    width: 38px;
    height: 38px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.96);
    color: #334155;
  }

  &.storageModeKiosk .modeArrow svg {
    width: 16px;
    height: 16px;
  }

  &.storageModeKiosk .modeGuide {
    margin-top: 18px;
    min-height: 64px;
    border-radius: 22px;
    background: rgba(255, 255, 255, 0.84);
    border: 1px solid rgba(17, 24, 39, 0.06);
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 0 18px;
    font-size: 20px;
    line-height: 1.45;
    font-weight: 800;
    color: #64748b;
    word-break: keep-all;
    flex-shrink: 0;
  }

  &.storageModeKiosk .modeGuide b {
    color: #1d4ed8;
  }

  &.storageTypeKiosk .topBar {
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    flex-shrink: 0;
  }

  &.storageTypeKiosk .topTitle {
    font-size: 54px;
    font-weight: 1000;
    letter-spacing: -0.04em;
    color: #111827;
  }

  &.storageTypeKiosk .topTotal {
    height: 74px;
    padding: 0 24px;
    font-size: 27px;
    font-weight: 800;
    color: #334155;
    background: rgba(255, 255, 255, 0.9);
    border: 1px solid rgba(17, 24, 39, 0.08);
    border-radius: 999px;
    box-shadow: 0 10px 28px rgba(0, 0, 0, 0.06);
    backdrop-filter: blur(6px);
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  &.storageTypeKiosk .topTotal b {
    font-size: 34px;
    margin: 0 6px;
    color: #1d4ed8;
  }

  &.storageTypeKiosk .storageGrid.twoByTwo {
    flex: 1;
    min-height: 0;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-template-rows: repeat(2, minmax(0, 1fr));
    gap: 22px;
  }

  &.storageTypeKiosk .storageCard {
    min-width: 0;
    min-height: 0;
    background: rgba(255, 255, 255, 0.95);
    border: 4px solid #d7dde5;
    border-radius: 28px;
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    box-shadow: 0 18px 45px rgba(0, 0, 0, 0.08);
    transition:
      transform 0.12s ease,
      box-shadow 0.12s ease,
      border-color 0.12s ease,
      filter 0.12s ease;
    -webkit-tap-highlight-color: transparent;
  }

  &.storageTypeKiosk .storageCard:hover {
    transform: translateY(-3px);
    box-shadow: 0 22px 55px rgba(0, 0, 0, 0.12);
    border-color: #bfc8d6;
  }

  &.storageTypeKiosk .storageCard:active {
    transform: translateY(-1px) scale(0.995);
    filter: brightness(0.99);
  }

  &.storageTypeKiosk .storageCard.selected {
    border-color: #4c80f1;
    box-shadow: 0 24px 60px rgba(76, 128, 241, 0.18);
  }

  &.storageTypeKiosk .cardInner {
    width: 100%;
    padding: 24px 22px 20px;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  &.storageTypeKiosk .cardTop {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &.storageTypeKiosk .iconWrap {
    width: 232px;
    height: 232px;
    margin: 0 auto 14px;
    border-radius: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border: 1px solid rgba(76, 128, 241, 0.12);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.55);
  }

  &.storageTypeKiosk .iconWrap.iconType0 {
    background: rgba(59, 130, 246, 0.10);
  }

  &.storageTypeKiosk .iconWrap.iconType1 {
    background: rgba(245, 158, 11, 0.10);
  }

  &.storageTypeKiosk .iconWrap.iconType2 {
    background: rgba(100, 116, 139, 0.10);
  }

  &.storageTypeKiosk .icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
  }

  &.storageTypeKiosk .icon svg {
    width: 132px;
    height: 132px;
    stroke-width: 2.1;
  }

  &.storageTypeKiosk .iconWrap.iconType0 .icon svg {
    color: #2563eb;
  }

  &.storageTypeKiosk .iconWrap.iconType1 .icon svg {
    color: #d97706;
  }

  &.storageTypeKiosk .iconWrap.iconType2 .icon svg {
    color: #334155;
  }

  &.storageTypeKiosk .name {
    text-align: center;
    font-size: 40px;
    font-weight: 1000;
    letter-spacing: -0.03em;
    color: #111827;
    margin-bottom: 6px;
    flex-shrink: 0;
  }

  &.storageTypeKiosk .price {
    text-align: center;
    font-size: 24px;
    font-weight: 900;
    letter-spacing: -0.02em;
    color: #475569;
    min-height: 30px;
    flex-shrink: 0;
  }

  &.storageTypeKiosk .stepperRow {
    margin-top: auto;
    padding-top: 18px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &.storageTypeKiosk .stepper {
    width: 100%;
    height: 92px;
    display: grid;
    grid-template-columns: 1fr 1.15fr 1fr;
    align-items: stretch;
    border: 2px solid rgba(17, 24, 39, 0.08);
    border-radius: 22px;
    overflow: hidden;
    background: rgba(243, 246, 251, 0.95);
  }

  &.storageTypeKiosk .btn {
    height: 100%;
    width: 100%;
    border: none;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 54px;
    font-weight: 1000;
    line-height: 1;
    color: #111827;
    cursor: pointer;
    transition: background 0.12s ease, transform 0.08s ease, filter 0.12s ease;
  }

  &.storageTypeKiosk .btn:hover {
    background: rgba(17, 24, 39, 0.05);
  }

  &.storageTypeKiosk .btn:active {
    transform: scale(0.99);
    filter: brightness(0.98);
  }

  &.storageTypeKiosk .btn.plus {
    color: #1d4ed8;
  }

  &.storageTypeKiosk .btn.minus {
    color: #0f172a;
  }

  &.storageTypeKiosk .count {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: 2px solid rgba(17, 24, 39, 0.08);
    border-right: 2px solid rgba(17, 24, 39, 0.08);
    font-size: 42px;
    font-weight: 1100;
    line-height: 1;
    color: #111827;
    letter-spacing: -0.02em;
    background: rgba(255, 255, 255, 0.78);
  }

  &.storageTypeKiosk .summaryCard {
    background: linear-gradient(180deg, #eef4ff 0%, #f8fbff 100%);
    border-color: #d7e3ff;
  }

  &.storageTypeKiosk .summaryInner {
    width: 100%;
    padding: 26px 24px;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  &.storageTypeKiosk .summaryBadge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    height: 40px;
    padding: 0 14px;
    border-radius: 999px;
    background: rgba(76, 128, 241, 0.12);
    color: #2f66e7;
    font-size: 17px;
    font-weight: 900;
    margin-bottom: 16px;
  }

  &.storageTypeKiosk .summaryTitle {
    font-size: 32px;
    line-height: 1.28;
    font-weight: 1000;
    letter-spacing: -0.03em;
    color: #0f172a;
    margin-bottom: 14px;
  }

  &.storageTypeKiosk .summaryDesc {
    font-size: 21px;
    line-height: 1.55;
    color: #64748b;
    font-weight: 700;
    word-break: keep-all;
  }

  &.storageTypeKiosk .summaryTotalBox {
    margin-top: auto;
    min-height: 92px;
    border-radius: 22px;
    background: rgba(255, 255, 255, 0.96);
    border: 2px solid #d7e3ff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 22px;
    flex-shrink: 0;
  }

  &.storageTypeKiosk .summaryTotalBox span {
    font-size: 24px;
    font-weight: 800;
    color: #475569;
  }

  &.storageTypeKiosk .summaryTotalBox strong {
    font-size: 40px;
    font-weight: 1000;
    color: #2f66e7;
    letter-spacing: -0.03em;
  }

  &.storageTypeKiosk .bottomHint {
    margin-top: 14px;
    min-height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: 800;
    color: #64748b;
    flex-shrink: 0;
  }

  &.storageTypeKiosk .bottomHint b {
    color: #1d4ed8;
  }

  @media screen and (max-width: 767px) {
    padding: 14px;

    &.storageModeKiosk .topBar {
      min-height: auto;
      margin-bottom: 10px;
      gap: 10px;
      flex-direction: column;
      align-items: stretch;
    }

    &.storageModeKiosk .topText {
      gap: 8px;
    }

    &.storageModeKiosk .topTitle {
      font-size: 22px;
    }

    &.storageModeKiosk .topDesc {
      font-size: 12px;
      line-height: 1.5;
    }

    &.storageModeKiosk .topTotal {
      min-width: 0;
      width: fit-content;
      height: 42px;
      padding: 0 14px;
      font-size: 14px;
    }

    &.storageModeKiosk .modeGrid {
      grid-template-columns: 1fr;
      gap: 10px;
      overflow-y: auto;
    }

    &.storageModeKiosk .modeCard {
      border-radius: 18px;
      border-width: 3px;
    }

    &.storageModeKiosk .modeInner {
      padding: 14px;
      gap: 10px;
    }

    &.storageModeKiosk .modeBadge {
      min-height: 28px;
      padding: 0 10px;
      font-size: 10px;
    }

    &.storageModeKiosk .modeIconWrap {
      width: 88px;
      height: 88px;
      border-radius: 18px;
    }

    &.storageModeKiosk .modeIconWrap svg {
      width: 42px;
      height: 42px;
    }

    &.storageModeKiosk .modeTitle {
      font-size: 24px;
    }

    &.storageModeKiosk .modeDesc {
      font-size: 13px;
      line-height: 1.5;
    }

    &.storageModeKiosk .modeNote {
      min-height: 28px;
      padding: 0 10px;
      font-size: 10px;
    }

    &.storageModeKiosk .modeFooter {
      min-height: 50px;
      border-radius: 14px;
      padding: 0 14px;
    }

    &.storageModeKiosk .modeState {
      font-size: 16px;
    }

    &.storageModeKiosk .modeArrow {
      width: 26px;
      height: 26px;
    }

    &.storageModeKiosk .modeArrow svg {
      width: 12px;
      height: 12px;
    }

    &.storageModeKiosk .modeGuide {
      margin-top: 12px;
      min-height: 48px;
      border-radius: 14px;
      padding: 0 12px;
      font-size: 12px;
    }

    &.storageTypeKiosk .topBar {
      height: 72px;
      margin-bottom: 10px;
    }

    &.storageTypeKiosk .topTitle {
      font-size: 20px;
    }

    &.storageTypeKiosk .topTotal {
      height: 42px;
      font-size: 12px;
      padding: 0 12px;
    }

    &.storageTypeKiosk .topTotal b {
      font-size: 14px;
    }

    &.storageTypeKiosk .storageGrid.twoByTwo {
      grid-template-columns: 1fr;
      grid-template-rows: auto;
      gap: 10px;
      overflow-y: auto;
    }

    &.storageTypeKiosk .storageCard {
      border-radius: 18px;
      border-width: 3px;
    }

    &.storageTypeKiosk .cardInner,
    &.storageTypeKiosk .summaryInner {
      padding: 14px;
    }

    &.storageTypeKiosk .iconWrap {
      width: 88px;
      height: 88px;
      border-radius: 18px;
      margin-bottom: 10px;
    }

    &.storageTypeKiosk .icon svg {
      width: 52px;
      height: 52px;
    }

    &.storageTypeKiosk .name {
      font-size: 20px;
    }

    &.storageTypeKiosk .price {
      font-size: 13px;
      min-height: 18px;
    }

    &.storageTypeKiosk .stepperRow {
      padding-top: 12px;
    }

    &.storageTypeKiosk .stepper {
      height: 56px;
      border-radius: 14px;
    }

    &.storageTypeKiosk .btn {
      font-size: 34px;
    }

    &.storageTypeKiosk .count {
      font-size: 22px;
    }

    &.storageTypeKiosk .summaryBadge {
      height: 28px;
      font-size: 11px;
      padding: 0 10px;
      margin-bottom: 10px;
    }

    &.storageTypeKiosk .summaryTitle {
      font-size: 18px;
      margin-bottom: 8px;
    }

    &.storageTypeKiosk .summaryDesc {
      font-size: 12px;
      line-height: 1.5;
    }

    &.storageTypeKiosk .summaryTotalBox {
      min-height: 56px;
      border-radius: 14px;
      padding: 0 14px;
      margin-top: 12px;
    }

    &.storageTypeKiosk .summaryTotalBox span {
      font-size: 12px;
    }

    &.storageTypeKiosk .summaryTotalBox strong {
      font-size: 22px;
    }

    &.storageTypeKiosk .bottomHint {
      margin-top: 10px;
      font-size: 12px;
      min-height: 28px;
    }
  }
`;

export const RetrieveContainer = styled.div`
  width: 100vw;
  height: 100vh;
  .content {
    width: 100vw;
    display: flex;
    flex-direction: column;
    .tabs {
      height: 86px;
      line-height: 86px;
      font-size: 30px;
      ul {
        height: 100%;
        display: flex;
        li {
          flex: 1;
          height: 100%;
          display: inline-block;
          text-align: center;
          font-weight: 700;
          border-bottom: 9px solid transparent;
          cursor: pointer;
          &.active {
            border-bottom: 9px solid #4c80f1;
          }
        }
      }
    }
    .slideWrapper {
      padding: 28px 0;
      overflow: hidden;
      display: flex;
      position: relative;
      height: calc(100% - 86px);
      background: #e9edf0;
      .slideContent {
        flex: 0 0 100%;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        transition: 0.5s;
        overflow: hidden;
        .contactInputFields {
          position: relative;
          width: 100%;
          height: 100%;
          display: flex;
          .contactInputSlide {
            flex: 0 0 100%;
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            transition: 0.5s;
            overflow: hidden;
          }
        }
        .inputBox {
          background: #fff;
          max-width: 584px;
          height: 100%;
          margin: 0 auto;
        }
        .inputFields {
          height: 100px;
          input {
            width: 100%;
            height: 100%;
            font-size: 48px;
            height: 100%;
            text-align: center;
            font-weight: 700;
            border: 1px solid #e9edf0;
            &:focus {
              border: 1px solid #e9edf0 !important;
              box-shadow: none;
            }
          }
        }
        .keyboardFields {
          height: calc(100% - 200px);
        }
        .inputActions {
          height: 100px;
          width: 100%;
          button {
            width: 100%;
            height: 100%;
            font-size: 30px;
            background: #fff;
            font-weight: 700;
            border: 1px solid #e9edf0;
          }
        }
      }
    }
  }
`;

export const ResultNotifyContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  padding: 34px 42px 36px;
  background:
    radial-gradient(920px 480px at 12% 4%, rgba(184, 214, 255, 0.48) 0%, transparent 58%),
    radial-gradient(860px 460px at 88% 8%, rgba(210, 227, 255, 0.56) 0%, transparent 60%),
    radial-gradient(1200px 560px at 50% 100%, rgba(255, 255, 255, 0.66) 0%, transparent 64%),
    linear-gradient(180deg, #edf4ff 0%, #eaf2ff 36%, #e7efff 100%);

  * {
    box-sizing: border-box;
  }

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    pointer-events: none;
    opacity: 0.9;
    background:
      radial-gradient(circle at 8% 10%, rgba(255, 255, 255, 0.95) 0 2px, transparent 3px),
      radial-gradient(circle at 15% 24%, rgba(255, 255, 255, 0.9) 0 1.5px, transparent 2.5px),
      radial-gradient(circle at 26% 8%, rgba(255, 255, 255, 0.95) 0 2px, transparent 3px),
      radial-gradient(circle at 38% 18%, rgba(255, 255, 255, 0.88) 0 1.5px, transparent 2.5px),
      radial-gradient(circle at 52% 7%, rgba(255, 255, 255, 0.95) 0 2px, transparent 3px),
      radial-gradient(circle at 64% 16%, rgba(255, 255, 255, 0.88) 0 1.5px, transparent 2.5px),
      radial-gradient(circle at 78% 10%, rgba(255, 255, 255, 0.95) 0 2px, transparent 3px),
      radial-gradient(circle at 90% 22%, rgba(255, 255, 255, 0.9) 0 1.5px, transparent 2.5px),
      radial-gradient(circle at 86% 72%, rgba(255, 255, 255, 0.8) 0 1.5px, transparent 2.5px),
      radial-gradient(circle at 12% 82%, rgba(255, 255, 255, 0.82) 0 2px, transparent 3px);
    animation: resultTwinkle 3.4s ease-in-out infinite;
  }

  @keyframes resultTwinkle {
    0%,
    100% {
      opacity: 0.72;
    }
    50% {
      opacity: 1;
    }
  }

  .result {
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 980px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 22px;
  }

  .info {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    padding: 30px 36px 24px;
    border-radius: 38px;
    background: rgba(255, 255, 255, 0.84);
    backdrop-filter: blur(12px);
    border: 2px solid rgba(255, 255, 255, 0.72);
    box-shadow:
      0 28px 70px rgba(76, 128, 241, 0.14),
      inset 0 1px 0 rgba(255, 255, 255, 0.94);
  }

  .resultInfo {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 20px;
    margin-bottom: 24px;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(148, 163, 184, 0.18);
  }

  .resultInfo .user {
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-width: 0;
  }

  .resultInfo .user > div {
    display: flex;
    align-items: baseline;
    gap: 12px;
    flex-wrap: wrap;
  }

  .resultInfo .user .tit {
    color: #0f172a;
    font-size: 34px;
    font-weight: 1000;
    letter-spacing: -0.06em;
    line-height: 1;
  }

  .resultInfo .user .con {
    color: #475569;
    font-size: 22px;
    font-weight: 900;
    letter-spacing: -0.04em;
    line-height: 1.2;
  }

  .toggleButton {
    flex: 0 0 auto;
    min-width: 150px;
    height: 78px;
    padding: 0 28px;
    border: none;
    border-radius: 24px;
    background: linear-gradient(180deg, #ffffff 0%, #f4f8ff 100%);
    color: #4c80f1;
    font-size: 24px;
    font-weight: 1000;
    letter-spacing: -0.05em;
    box-shadow:
      0 16px 32px rgba(76, 128, 241, 0.12),
      inset 0 1px 0 rgba(255, 255, 255, 0.95);
    cursor: pointer;
    transition: transform 0.14s ease, box-shadow 0.14s ease;
  }

  .toggleButton:hover {
    transform: translateY(-1px);
    box-shadow:
      0 20px 36px rgba(76, 128, 241, 0.16),
      inset 0 1px 0 rgba(255, 255, 255, 0.95);
  }

  .toggleButton:active {
    transform: scale(0.985);
  }

  .storageInfo {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding-right: 6px;

    &::-webkit-scrollbar {
      width: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background: linear-gradient(180deg, #a8c7ff 0%, #6b9cff 100%);
      border-radius: 999px;
      border: 2px solid rgba(255, 255, 255, 0.75);
    }

    &::-webkit-scrollbar-track {
      background: rgba(226, 232, 240, 0.72);
      border-radius: 999px;
    }
  }

  .storageInfo .type {
    display: flex;
    gap: 22px;
    margin-bottom: 18px;
    padding: 18px 20px;
    border-radius: 28px;
    background: rgba(248, 250, 252, 0.9);
    border: 1px solid rgba(226, 232, 240, 0.95);
    box-shadow:
      inset 0 1px 0 rgba(255, 255, 255, 0.92),
      0 8px 20px rgba(76, 128, 241, 0.04);

    &:last-child {
      margin-bottom: 0;
    }
  }

  .storageInfo .type > p {
    flex: 0 0 116px;
    margin: 0;
    padding-top: 16px;
    color: #0f172a;
    font-size: 30px;
    font-weight: 1000;
    letter-spacing: -0.06em;
    line-height: 1;
  }

  .storageInfo .type ul {
    width: 100%;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .storageInfo .type ul li {
    margin-bottom: 14px;
    list-style: none;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .storageCard {
    width: 100%;
    min-height: 106px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 18px;
    padding: 18px 22px;
    border-radius: 24px;
    background: linear-gradient(180deg, #ffffff 0%, #f9fbff 100%);
    border: 2px solid #d9e4f2;
    box-shadow:
      0 10px 24px rgba(76, 128, 241, 0.06),
      inset 0 1px 0 rgba(255, 255, 255, 0.96);
    cursor: pointer;
    transition:
      transform 0.14s ease,
      box-shadow 0.14s ease,
      border-color 0.14s ease,
      background 0.14s ease;
  }

  .storageRow:hover .storageCard {
    transform: translateY(-1px);
    border-color: #bdd0f8;
    box-shadow:
      0 18px 34px rgba(76, 128, 241, 0.1),
      inset 0 1px 0 rgba(255, 255, 255, 0.96);
  }

  .storageRow.active .storageCard {
    border-color: #4c80f1;
    background: linear-gradient(180deg, #ffffff 0%, #eef5ff 100%);
    box-shadow:
      0 20px 40px rgba(76, 128, 241, 0.16),
      0 0 0 4px rgba(76, 128, 241, 0.1);
  }

  .storageMain {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 18px;
  }

  .iconBox {
    width: 70px;
    height: 70px;
    flex: 0 0 70px;
    border-radius: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(180deg, #f4f8ff 0%, #e9f1ff 100%);
    border: 1px solid #d7e3fb;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.96);
  }

  .iconBox svg {
    width: 34px;
    height: 34px;
    color: #4c80f1;
  }

  .storageText {
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 5px;
  }

  .storageText .label {
    color: #7c8ba1;
    font-size: 15px;
    font-weight: 900;
    letter-spacing: -0.03em;
    line-height: 1.1;
  }

  .storageText .number {
    color: #0f172a;
    font-size: 40px;
    font-weight: 1000;
    line-height: 1;
    letter-spacing: -0.07em;
  }

  .storageInfo .type ul li .customInput {
    position: relative;
    flex: 0 0 42px;
    width: 42px;
    height: 42px;
    cursor: pointer;
    display: block;
  }

  .storageInfo .type ul li .customInput input {
    position: absolute;
    opacity: 0;
    inset: 0;
    cursor: pointer;
  }

  .storageInfo .type ul li .customInput .checkmark {
    position: absolute;
    inset: 0;
    border-radius: 12px;
    border: 3px solid #c9d4e2;
    background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.95);
    transition: all 0.18s ease;
  }

  .storageInfo .type ul li .customInput .checkmark::after {
    content: "";
    position: absolute;
    left: 50%;
    top: 44%;
    width: 10px;
    height: 18px;
    border: solid #fff;
    border-width: 0 4px 4px 0;
    opacity: 0;
    transform: translate(-50%, -50%) rotate(45deg) scale(0.7);
    transition: all 0.18s ease;
  }

  .storageInfo .type ul li .customInput input:checked ~ .checkmark {
    border-color: #4c80f1;
    background: linear-gradient(180deg, #6ea0ff 0%, #4c80f1 100%);
    box-shadow: 0 12px 22px rgba(76, 128, 241, 0.22);
  }

  .storageInfo .type ul li .customInput input:checked ~ .checkmark::after {
    opacity: 1;
    transform: translate(-50%, -50%) rotate(45deg) scale(1);
  }

  .feeInfo {
    min-height: 68px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-end;
    gap: 6px;
    margin-top: 18px;
    padding-top: 14px;
    border-top: 1px solid rgba(148, 163, 184, 0.14);
    color: #64748b;
    font-size: 16px;
    font-weight: 800;
    letter-spacing: -0.02em;
  }

  .feeInfo strong {
    color: #e11d48;
    font-size: 18px;
    font-weight: 1000;
    letter-spacing: -0.03em;
  }

  .buttons {
    width: 100%;
    display: flex;
    gap: 16px;
  }

  .buttons button {
    flex: 1;
    height: 88px;
    border: none;
    border-radius: 28px;
    font-size: 34px;
    font-weight: 1000;
    letter-spacing: -0.06em;
    cursor: pointer;
    transition: transform 0.12s ease, box-shadow 0.12s ease, opacity 0.12s ease;
  }

  .buttons button:active {
    transform: scale(0.988);
  }

  .buttons button:first-child {
    background: rgba(255, 255, 255, 0.92);
    color: #0f172a;
    box-shadow:
      0 18px 38px rgba(15, 23, 42, 0.08),
      inset 0 1px 0 rgba(255, 255, 255, 0.92);
  }

  .buttons button:last-child {
    background: linear-gradient(180deg, #6a9cff 0%, #4c80f1 100%);
    color: #fff;
    box-shadow: 0 22px 40px rgba(76, 128, 241, 0.25);
  }

  .buttons button:last-child:disabled {
    opacity: 0.45;
    cursor: default;
    box-shadow: none;
  }

  .notDetails {
    position: relative;
    z-index: 1;
    max-width: 860px;
    margin: auto;
    padding: 48px 32px;
    border-radius: 32px;
    background: rgba(255, 255, 255, 0.9);
    color: #334155;
    text-align: center;
    font-size: 28px;
    font-weight: 900;
    letter-spacing: -0.04em;
    box-shadow: 0 22px 60px rgba(59, 130, 246, 0.12);
  }

  @media screen and (max-width: 767px) {
    padding: 14px 12px 12px;

    .result {
      gap: 12px;
    }

    .info {
      padding: 16px 14px 14px;
      border-radius: 24px;
    }

    .resultInfo {
      flex-direction: column;
      align-items: stretch;
      gap: 10px;
      margin-bottom: 14px;
      padding-bottom: 12px;
    }

    .resultInfo .user {
      gap: 6px;
    }

    .resultInfo .user > div {
      gap: 6px;
    }

    .resultInfo .user .tit {
      font-size: 22px;
    }

    .resultInfo .user .con {
      font-size: 14px;
    }

    .toggleButton {
      width: 100%;
      min-width: 0;
      height: 52px;
      border-radius: 16px;
      font-size: 17px;
    }

    .storageInfo {
      padding-right: 2px;
    }

    .storageInfo .type {
      flex-direction: column;
      gap: 10px;
      margin-bottom: 12px;
      padding: 12px;
      border-radius: 18px;
    }

    .storageInfo .type > p {
      flex: none;
      width: 100%;
      padding-top: 0;
      font-size: 20px;
    }

    .storageInfo .type ul li {
      margin-bottom: 10px;
    }

    .storageCard {
      min-height: 80px;
      padding: 12px 14px;
      gap: 12px;
      border-radius: 18px;
    }

    .storageMain {
      gap: 12px;
    }

    .iconBox {
      width: 50px;
      height: 50px;
      flex-basis: 50px;
      border-radius: 14px;
    }

    .iconBox svg {
      width: 24px;
      height: 24px;
    }

    .storageText .label {
      font-size: 11px;
    }

    .storageText .number {
      font-size: 25px;
    }

    .storageInfo .type ul li .customInput {
      width: 30px;
      height: 30px;
      flex-basis: 30px;
    }

    .storageInfo .type ul li .customInput .checkmark {
      border-radius: 9px;
      border-width: 2px;
    }

    .storageInfo .type ul li .customInput .checkmark::after {
      width: 7px;
      height: 13px;
      border-width: 0 3px 3px 0;
    }

    .feeInfo {
      min-height: 34px;
      margin-top: 10px;
      padding-top: 10px;
      font-size: 12px;
    }

    .feeInfo strong {
      font-size: 12px;
    }

    .buttons {
      gap: 10px;
    }

    .buttons button {
      height: 56px;
      border-radius: 18px;
      font-size: 19px;
    }

    .notDetails {
      padding: 30px 18px;
      border-radius: 22px;
      font-size: 18px;
    }
  }
`;

export const ReserveListContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 34px 42px 36px;
  background:
    radial-gradient(920px 480px at 12% 4%, rgba(184, 214, 255, 0.48) 0%, transparent 58%),
    radial-gradient(860px 460px at 88% 8%, rgba(210, 227, 255, 0.56) 0%, transparent 60%),
    linear-gradient(180deg, #edf4ff 0%, #eaf2ff 36%, #e7efff 100%);

  * {
    box-sizing: border-box;
  }

  .reserveWrap {
    max-width: 980px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 22px;
  }

  .topBox {
    position: relative;
    padding: 28px 32px 24px;
    border-radius: 32px;
    background: rgba(255, 255, 255, 0.86);
    backdrop-filter: blur(12px);
    box-shadow:
      0 24px 60px rgba(76, 128, 241, 0.1),
      inset 0 1px 0 rgba(255, 255, 255, 0.9);
    overflow: hidden;
  }

  .topBox::before {
    content: "";
    position: absolute;
    inset: 0;
    background:
      radial-gradient(circle at top left, rgba(76, 128, 241, 0.12) 0%, transparent 28%),
      radial-gradient(circle at bottom right, rgba(123, 177, 255, 0.14) 0%, transparent 30%);
    pointer-events: none;
  }

  .titleRow {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    gap: 18px;
  }

  .titleBadge {
    width: 78px;
    height: 78px;
    border-radius: 24px;
    flex: 0 0 78px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(180deg, #ffffff 0%, #edf5ff 100%);
    color: #4c80f1;
    box-shadow:
      0 16px 36px rgba(76, 128, 241, 0.14),
      inset 0 1px 0 rgba(255, 255, 255, 0.95);
  }

  .titleBadge svg {
    width: 36px;
    height: 36px;
  }

  .titleTextBox {
    min-width: 0;
  }

  .title {
    font-size: 40px;
    font-weight: 1000;
    color: #0f172a;
    letter-spacing: -0.06em;
    line-height: 1.1;
  }

  .sub {
    margin-top: 8px;
    font-size: 20px;
    font-weight: 800;
    color: #64748b;
    letter-spacing: -0.03em;
  }

  .guidePill {
    position: relative;
    z-index: 1;
    margin-top: 18px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 44px;
    padding: 0 18px;
    border-radius: 999px;
    background: rgba(76, 128, 241, 0.1);
    color: #2f5fd6;
    font-size: 15px;
    font-weight: 900;
    letter-spacing: -0.02em;
  }

  .listBox {
    flex: 1;
    min-height: 0;
    padding: 22px;
    border-radius: 32px;
    background: rgba(255, 255, 255, 0.86);
    backdrop-filter: blur(10px);
    box-shadow:
      0 24px 60px rgba(76, 128, 241, 0.1),
      inset 0 1px 0 rgba(255, 255, 255, 0.92);
    overflow-y: auto;
  }

  .listBox::-webkit-scrollbar {
    width: 12px;
  }

  .listBox::-webkit-scrollbar-track {
    background: transparent;
  }

  .listBox::-webkit-scrollbar-thumb {
    border-radius: 999px;
    background: rgba(148, 163, 184, 0.35);
    border: 3px solid rgba(255, 255, 255, 0.8);
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  li {
    margin-bottom: 14px;
  }

  li:last-child {
    margin-bottom: 0;
  }

  .reserveCard {
    position: relative;
    width: 100%;
    min-height: 112px;
    border: 2px solid transparent;
    border-radius: 28px;
    padding: 22px 24px;
    background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    cursor: pointer;
    overflow: hidden;
    box-shadow:
      0 14px 34px rgba(76, 128, 241, 0.08),
      inset 0 1px 0 rgba(255, 255, 255, 0.94);
    transition:
      transform 0.14s ease,
      box-shadow 0.14s ease,
      border-color 0.14s ease,
      background 0.14s ease;
  }

  .reserveCard:hover {
    transform: translateY(-2px);
    box-shadow:
      0 20px 44px rgba(76, 128, 241, 0.12),
      inset 0 1px 0 rgba(255, 255, 255, 0.96);
  }

  .reserveCard:active {
    transform: scale(0.995);
  }

  .reserveCard.active {
    border-color: #4c80f1;
    background: linear-gradient(180deg, #ffffff 0%, #eef5ff 100%);
    box-shadow:
      0 24px 48px rgba(76, 128, 241, 0.16),
      0 0 0 5px rgba(76, 128, 241, 0.08);
  }

  .cardGlow {
    position: absolute;
    top: -30px;
    right: -20px;
    width: 180px;
    height: 180px;
    border-radius: 999px;
    background: radial-gradient(circle, rgba(123, 177, 255, 0.18) 0%, transparent 68%);
    pointer-events: none;
  }

  .left {
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .iconBox {
    width: 68px;
    height: 68px;
    border-radius: 20px;
    flex: 0 0 68px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(180deg, #f4f8ff 0%, #e9f1ff 100%);
    color: #4c80f1;
    box-shadow:
      0 12px 28px rgba(76, 128, 241, 0.1),
      inset 0 1px 0 rgba(255, 255, 255, 0.95);
  }

  .iconBox svg {
    width: 34px;
    height: 34px;
  }

  .textBox {
    min-width: 0;
    text-align: left;
  }

  .main {
    display: flex;
    align-items: baseline;
    gap: 10px;
    min-width: 0;
    font-size: 29px;
    font-weight: 1000;
    color: #0f172a;
    letter-spacing: -0.05em;
    line-height: 1.15;
  }

  .label {
    color: #475569;
    font-size: 20px;
    font-weight: 900;
    flex: 0 0 auto;
  }

  .main strong {
    color: #2563eb;
    min-width: 0;
    word-break: break-all;
  }

  .subText {
    margin-top: 8px;
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    font-size: 17px;
    font-weight: 800;
    color: #64748b;
    letter-spacing: -0.02em;
  }

  .dot {
    width: 6px;
    height: 6px;
    border-radius: 999px;
    background: #cbd5e1;
    flex: 0 0 6px;
  }

  .right {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    gap: 14px;
    position: relative;
    z-index: 1;
  }

  .status {
    height: 42px;
    padding: 0 15px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 1000;
    letter-spacing: -0.02em;
    white-space: nowrap;
  }

  .status svg {
    width: 16px;
    height: 16px;
    flex: 0 0 16px;
  }

  .status.ready {
    background: rgba(245, 158, 11, 0.14);
    color: #b45309;
  }

  .status.completed {
    background: rgba(37, 99, 235, 0.12);
    color: #2563eb;
  }

  .status.retrieved {
    background: rgba(34, 197, 94, 0.14);
    color: #15803d;
  }

  .status.canceled {
    background: rgba(239, 68, 68, 0.12);
    color: #b91c1c;
  }

  .status.expired {
    background: rgba(100, 116, 139, 0.14);
    color: #475569;
  }

  .status.default {
    background: rgba(148, 163, 184, 0.16);
    color: #475569;
  }

  .arrow {
    width: 42px;
    height: 42px;
    border-radius: 999px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(148, 163, 184, 0.1);
    color: #94a3b8;
    transition:
      transform 0.14s ease,
      background 0.14s ease,
      color 0.14s ease;
  }

  .arrow svg {
    width: 22px;
    height: 22px;
  }

  .reserveCard.active .arrow,
  .arrow.active {
    background: rgba(76, 128, 241, 0.14);
    color: #2563eb;
    transform: translateX(2px);
  }

  .empty {
    height: 100%;
    min-height: 320px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 24px;
  }

  .emptyIcon {
    width: 92px;
    height: 92px;
    border-radius: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(180deg, #f4f8ff 0%, #e9f1ff 100%);
    color: #4c80f1;
    box-shadow:
      0 16px 36px rgba(76, 128, 241, 0.12),
      inset 0 1px 0 rgba(255, 255, 255, 0.94);
  }

  .emptyIcon svg {
    width: 42px;
    height: 42px;
  }

  .emptyTitle {
    margin-top: 18px;
    color: #334155;
    font-size: 28px;
    font-weight: 1000;
    letter-spacing: -0.04em;
  }

  .emptySub {
    margin-top: 10px;
    color: #64748b;
    font-size: 18px;
    font-weight: 800;
    letter-spacing: -0.02em;
  }

  @media screen and (max-width: 767px) {
    padding: 14px 12px 12px;

    .reserveWrap {
      gap: 14px;
    }

    .topBox {
      padding: 18px 16px 16px;
      border-radius: 22px;
    }

    .titleRow {
      gap: 12px;
    }

    .titleBadge {
      width: 52px;
      height: 52px;
      border-radius: 16px;
      flex-basis: 52px;
    }

    .titleBadge svg {
      width: 24px;
      height: 24px;
    }

    .title {
      font-size: 26px;
    }

    .sub {
      margin-top: 5px;
      font-size: 14px;
    }

    .guidePill {
      margin-top: 12px;
      min-height: 34px;
      padding: 0 12px;
      font-size: 12px;
    }

    .listBox {
      padding: 14px;
      border-radius: 22px;
    }

    li {
      margin-bottom: 10px;
    }

    .reserveCard {
      min-height: 88px;
      padding: 14px;
      border-radius: 18px;
      gap: 10px;
    }

    .cardGlow {
      width: 120px;
      height: 120px;
    }

    .left {
      gap: 12px;
    }

    .iconBox {
      width: 46px;
      height: 46px;
      border-radius: 14px;
      flex-basis: 46px;
    }

    .iconBox svg {
      width: 22px;
      height: 22px;
    }

    .main {
      gap: 6px;
      font-size: 20px;
    }

    .label {
      font-size: 14px;
    }

    .subText {
      margin-top: 5px;
      gap: 8px;
      font-size: 12px;
    }

    .dot {
      width: 4px;
      height: 4px;
      flex-basis: 4px;
    }

    .right {
      gap: 8px;
    }

    .status {
      height: 30px;
      padding: 0 10px;
      gap: 5px;
      font-size: 11px;
    }

    .status svg {
      width: 12px;
      height: 12px;
      flex-basis: 12px;
    }

    .arrow {
      width: 30px;
      height: 30px;
    }

    .arrow svg {
      width: 16px;
      height: 16px;
    }

    .empty {
      min-height: 240px;
      padding: 12px;
    }

    .emptyIcon {
      width: 64px;
      height: 64px;
      border-radius: 20px;
    }

    .emptyIcon svg {
      width: 28px;
      height: 28px;
    }

    .emptyTitle {
      margin-top: 14px;
      font-size: 20px;
    }

    .emptySub {
      margin-top: 8px;
      font-size: 13px;
    }
  }
`;
